import Axios from "axios";
import React from "react";

const API_URL = process.env.API;
//APP_URL for api front url defined
const AxiosInstance = Axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {},
});
//here axios instance create

const setAuthorizationToken = (token) => {
  AxiosInstance.defaults.headers.common.reftoken = token
    ? token?.replace(/ /g, "+")
    : "";
};
const setAuthorizationLang = (lang) => {
  AxiosInstance.defaults.headers.common.lang = lang ? lang : "en";
};
//set token for authorization

async function postMethod(endpoint, data) {
  return new Promise((resolve) => {
    var config = {
      method: "post",
      url: endpoint,
      data: data,
    };
    AxiosInstance(config).then(
      (response) => {
        resolve(response.data);
      },
      (error) => {
        if (error.response.status === 401) {
          resolve({
            success: false,
            status: error.response.status,
            message: "failed!",
          });
        }
        if (error?.response?.data) {
          resolve(
            error?.response?.data
              ? error?.response?.data
              : {
                  success: false,
                  status: error.response.status,
                  message: "failed!",
                }
          );
        } else {
          resolve({
            success: false,
            status: error.response.status,
            message: "failed!",
          });
        }
      }
    );
  });
}
//postmethod create function

async function getMethod(endpoint, params = {}, config = {}) {
  return new Promise((resolve) => {
    var config = {
      method: "get",
      url: endpoint,
      params: params,
      ...config
    };
    AxiosInstance(config).then(
      (response) => {
        resolve(response.data);
      },
      (error) => {
        if (error?.response?.data) {
          resolve(
            error?.response?.data
              ? error?.response?.data
              : {
                  success: false,
                  status: error.response.status,
                  message: "failed!",
                }
          );
        } else {
          resolve({
            success: false,
            status: error.response?.status,
            message: "failed!",
          });
        }
      }
    );
  });
}
export { postMethod, getMethod, setAuthorizationToken, setAuthorizationLang };
